const SEO = [
    {
        page: "home",
        description:
            "Expert hair salon in Falls Church, VA specializing in balayage, color correction & precision cuts. Master colorist Anna transforms hair with stunning highlights & natural-looking color. Serving McLean, Vienna, Tysons Corner & Northern Virginia. Book today!",
        keywords: [
            "balayage Falls Church VA",
            "balayage McLean VA",
            "balayage Vienna VA",
            "balayage Tysons Corner",
            "balayage Arlington VA",
            "balayage Reston VA",
            "highlights specialist VA",
            "best balayage Northern VA",
            "hair color correction Falls Church",
            "hair color correction McLean",
            "hair color correction Tysons",
            "natural balayage specialist",
            "dimensional highlights VA",
            "blonde balayage expert",
            "foil highlights Northern VA",
            "hair color specialist Vienna",
            "Asian hair balayage Tysons",
            "Pasmo salon",
            "Leesburg Pike hair salon",
            "hair transformation McLean",
            "blonde specialist Arlington",
            "balayage and highlights Reston",
            "affordable luxury salon Tysons",
            "experienced colorist VA",
            "hair painting expert",
            "beauty salon near me",
            "top rated hair salon VA",
            "best hair salon McLean",
            "premium salon Tysons Corner",
        ],
    },
    {
        page: "about",
        description:
            "Meet Anna, an award-winning hair stylist and balayage specialist in Falls Church, VA. Expert in creating custom balayage, highlights, and color corrections. Specialized in Asian hair coloring techniques for natural-looking results.",
        keywords: [
            "balayage specialist Anna",
            "professional colorist Falls Church",
            "Asian hair balayage expert",
            "highlights specialist VA",
            "color correction expert",
            "balayage master stylist",
            "hair painting specialist",
            "Pasmo founder",
            "top hair colorist VA",
            "certified balayage expert"
        ],
    },
    {
        page: "projects",
        description:
            "View stunning hair transformations at Pasmo salon in Falls Church. Before & after gallery featuring balayage, highlights, color correction & precision cuts. See why we're Northern Virginia's top-rated hair salon. Book your transformation today!",
        keywords: [
            "hair transformation gallery",
            "before and after hair color",
            "balayage results Tysons",
            "hair color transformation",
            "best haircuts Falls Church",
            "premium hair services VA",
            "hair makeover specialist",
            "blonde specialist Tysons",
            "Asian hair transformation",
            "wedding hair specialist VA"
        ],
    },
    {
        page: "articles",
        description:
            "Expert hair care tips from Pasmo salon in Falls Church. Learn about balayage maintenance, color care, styling techniques & hair health. Professional advice from master colorist Anna for beautiful hair between salon visits.",
        keywords: [
            "professional hair care tips",
            "hair maintenance guide",
            "hair color maintenance",
            "salon styling tutorials",
            "hair treatment advice",
            "hair care blog Tysons",
            "hair trend updates",
            "hair health tips",
            "color protection advice",
            "styling tips for Asian hair"
        ],
    },
    {
        page: "contact",
        description:
            "Book your hair appointment at Pasmo salon - 7121 Leesburg Pike, Falls Church, VA 22043. Expert balayage, highlights & color correction services. Convenient location serving McLean, Vienna, Tysons & Arlington. Call or book online today!",
        keywords: [
            "book balayage Falls Church",
            "highlights appointment VA",
            "hair color consultation",
            "Pasmo location",
            "balayage consultation booking",
            "professional hair coloring",
            "salon appointment Falls Church",
            "hair color specialist booking",
            "balayage near me",
            "highlights consultation VA"
        ],
    },
];

export default SEO;
